import React from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { Box, Stack, Typography, TextField, Button } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DropDown from "../common/Dropdown/Dropdown";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import "moment/locale/de";
import ChipRadioGroup from "../common/RadioChip/RadioChip";
import RadioChipWithLabel from "../common/RadioChipWithLabel/RadioChipWithLabel";
import "./styles.scss";
import { PAYMENT_METHODS } from "../../variables/constants";
import AddressComp, { Address } from "../addressComp/AddressComp";

import NumericField from "../common/NumericField/NumericField";
import { useClientDetails } from "../../hooks/useClientDetails";

type NewStatementProps = {
  handleDrawerClose: Function;
};

const NewStatement = (props: NewStatementProps) => {
  const { clientOptions } = useClientDetails();
  const { selectedTransaction } = useSelector(
    (state: any) => state.reconcileState
  );
  
  const { checkDetails , achDetails , wireNumber } = selectedTransaction;
  const selectedMethod = !!selectedTransaction.wireNumber
    ? PAYMENT_METHODS.WIRE
    : !!selectedTransaction.checkDetails
      ? PAYMENT_METHODS.CHECK
      : PAYMENT_METHODS.ACH;
  const { handleDrawerClose } = props;
  const addressObj:Address = {
    address: checkDetails?.address ?? null,
    apartment: checkDetails?.apartment ?? null,
    city: checkDetails?.city ?? null,
    state: checkDetails?.state ?? null,
    zip: checkDetails?.zip ?? null,
    country: checkDetails?.country ?? null,
  };
  return (
    <Box className="new-transaction">
      <Stack spacing={3}>
        <DropDown
          val={selectedTransaction.clientId}
          setVal={() => {}}
          disabled
          options={clientOptions}
          label="Client"
          placeholder="Select a client"
          required
        />

        <DropDown
          val={selectedTransaction.account}
          setVal={() => {}}
          options={[
            {
              value: selectedTransaction.account,
              label: selectedTransaction.accountName,
            },
          ]}
          label="Account"
          placeholder="Select an account"
          required
          disabled
        />

        <Box className="account-box">
          <Typography className="account-title">Account Balance:</Typography>
          <Typography className="account-balance">{`$${selectedTransaction.balance}`}</Typography>
        </Box>
        <Box className="date-picker-container">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Transaction Date"
              className="date-picker-container"
              slotProps={{ textField: { size: "small" } }}
              defaultValue={dayjs(selectedTransaction.date)}
              disabled
              sx={{
                "& .Mui-selected": {
                  color: "#FFFFFF",
                  borderRadius: 2,
                  borderWidth: 1,
                  borderColor: "#e91e63",
                  border: "1px solid",
                  backgroundColor: "#f8bbd0",
                },
              }}
            />
          </LocalizationProvider>
        </Box>
        <RadioChipWithLabel
          label="Transaction Type"
          value={selectedTransaction.code}
          setValue={() => {}}
          options={
            !selectedTransaction.code.includes("Loan")
              ? [
                { value: "Deposit", label: "Deposit" },
                { value: "Withdrawal", label: "Withdrawal" },
                { value: "Transfer", label: "Transfer" },
              ]
              : [
                { value: "Loan Payment", label: "Loan Payment" },
                { value: "Loan Advance", label: "Loan Advance" },
              ]
          }
          disabled
        />
        {selectedTransaction.code === "Withdrawal" && (
          <ChipRadioGroup
            label="Method"
            value={selectedMethod}
            setValue={() => {}}
            options={Object.values(PAYMENT_METHODS)}
            disabled
          />
        )}
        {selectedTransaction.code === "Withdrawal" &&
          selectedMethod === "Wire" && (
          <TextField
            id="outlined-helperText"
            label="Wire Number"
            required
            size="small"
            value={wireNumber}
            onChange={() => {}}
            className="textfield-width"
            disabled
          />
        )}
        {selectedTransaction.code === "Withdrawal" &&
          selectedMethod === "Check" && (
          <>
            <TextField
              id="outlined-helperText"
              label="Payee"
              size="small"
              value={checkDetails?.payee}
              onChange={() => {}}
              fullWidth
              disabled
              required
            />
            <AddressComp
              address={addressObj}
              setAddress={() => {}}
              disabled
            />
            <TextField
              id="outlined-helperText"
              label="Check Memo"
              size="small"
              value={checkDetails?.memo}
              onChange={() => {}}
              fullWidth
              disabled
            />
          </>
        )}
        {selectedTransaction.code === "Withdrawal" &&
          selectedMethod === "ACH" && (
          <TextField
            id="outlined-helperText"
            label="ACH Details"
            size="small"
            value={achDetails}
            onChange={() => {}}
            fullWidth
            required
            disabled
          />
        )}
        <NumericField
          label="Amount"
          val={selectedTransaction.amount}
          setVal={() => {}}
          testId="amount"
          inputAdorment="$"
          decimalPlaces={2}
          required
          disabled
        />
        <TextField
          id="outlined-helperText"
          label="Description"
          value={selectedTransaction.description}
          onChange={() => {}}
          size="small"
          disabled
        />
        <ChipRadioGroup
          label="Status"
          value={selectedTransaction.status}
          setValue={() => {}}
          options={["Outstanding", "Reconciled", "Voided"]}
          disabled
        />

        {selectedTransaction.code !== "Transfer" && (
          <ChipRadioGroup
            label="Bank Transaction"
            value={selectedTransaction.bankTransactionType ?? ""}
            setValue={() => {}}
            options={["Credit", "Debit"]}
            disabled
          />)
        }

        <Stack direction="row" spacing={2}>
          <Button className="cancel-button" onClick={() => handleDrawerClose()}>
            CANCEL
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default NewStatement;
